'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GroupReservationService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../core/utils.js');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// ABI / Group Reservation
var GroupReservationService = exports.GroupReservationService = function () {
    function GroupReservationService($q, winresCloudService) {
        _classCallCheck(this, GroupReservationService);

        this.$q = $q;
        this.winresCloudService = winresCloudService;
    }

    _createClass(GroupReservationService, [{
        key: 'loadGroupManager',
        value: function loadGroupManager(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequestWithResponse('GroupReservationLoadGroupManager', {
                BookingNumber: bookingNumber
            });
        }
    }, {
        key: 'storeGroupManager',
        value: function storeGroupManager(bookingNumber, data, isTransfer, customMessage) {
            return this.winresCloudService.makeAuthenticatedRequestWithResponse('GroupReservationStoreGroupManager', {
                BookingNumber: bookingNumber,
                GroupManager: data,
                IsTransfer: isTransfer,
                CustomMessage: customMessage
            });
        }
    }, {
        key: 'getGroupManagerChangeMail',
        value: function getGroupManagerChangeMail(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequestWithResponse('GroupReservationGetGroupManagerChangeMail', {
                'BookingNumber': bookingNumber,
                'Language': this.winresCloudService.getLanguage()
            });
        }
    }, {
        key: 'getBookings',
        value: function getBookings() {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationGetBookings', {},
            // Show loading screen
            false);
        }
    }, {
        key: 'getBooking',
        value: function getBooking(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationGetBooking', {
                "BookingNumber": bookingNumber
            }, /*showSpinner=*/true);
        }
    }, {
        key: 'updatePassengers',
        value: function updatePassengers(bookingNumber, passengers) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationUpdatePassengers', {
                "BookingNumber": bookingNumber,
                "Passengers": passengers
            }, /*showSpinner=*/true);
        }
    }, {
        key: 'setClosedInternet',
        value: function setClosedInternet(bookingNumber, isClosed) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationSetClosedInternet', {
                "BookingNumber": bookingNumber,
                "IsClosed": isClosed
            }, /*showSpinner=*/true);
        }
    }, {
        key: 'getDefaultInvoices',
        value: function getDefaultInvoices(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationGetDefaultInvoices', {
                BookingNumber: bookingNumber
            },
            // Show loading screen
            false);
        }

        // Gets passengers for the reservation of the user. 

    }, {
        key: 'listPassengers',
        value: function listPassengers() {}
    }, {
        key: 'loadPassenger',
        value: function loadPassenger(bookingNumber, passengerID) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationLoadPassenger', {
                'BookingNumber': bookingNumber,
                'PassengerID': passengerID
            },
            // Show loading screen
            true);
        }

        // Updates or inserts passenger.

    }, {
        key: 'storePassenger',
        value: function storePassenger(bookingNumber, passenger, isAdding, isTransfer, customMessage, paymentsWhat) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationStorePassenger', {
                'BookingNumber': bookingNumber,
                'Passenger': passenger,
                'IsAdding': isAdding,
                'IsTransfer': isTransfer,
                'CustomMessage': customMessage,
                'PaymentsWhat': paymentsWhat
            }, true);
        }
    }, {
        key: 'removePassenger',
        value: function removePassenger(bookingNumber, passengerID) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationRemovePassenger', {
                'BookingNumber': bookingNumber,
                'PassengerID': passengerID
            }, true);
        }
    }, {
        key: 'getCabinInformation',
        value: function getCabinInformation(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationGetCabinInformation', {
                'BookingNumber': bookingNumber
            },
            /* showSpinner=*/true);
        }
    }, {
        key: 'saveCabinAssignments',
        value: function saveCabinAssignments(bookingNumber, assignments) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationSaveCabinAssignments', {
                'BookingNumber': bookingNumber,
                'Assignments': assignments
            },
            /* showSpinner=*/true);
        }
    }, {
        key: 'getExtraServiceInformation',
        value: function getExtraServiceInformation(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationGetExtraServiceInformation', {
                'BookingNumber': bookingNumber
            }, true);
        }
    }, {
        key: 'saveExtraServiceAssignments',
        value: function saveExtraServiceAssignments(bookingNumber, assignments) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationSaveExtraServiceAssignments', {
                'BookingNumber': bookingNumber,
                'Assignments': assignments
            }, true);
        }
    }, {
        key: 'registerPassengerUser',
        value: function registerPassengerUser(email, password) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationCreatePassengerUser', {
                'Email': email,
                'Password': password
            }, true);
        }
    }, {
        key: 'getPassengerFields',
        value: function getPassengerFields(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationGetPassengerFields', {
                BookingNumber: bookingNumber
            }, true);
        }
    }, {
        key: 'getPassengerBalance',
        value: function getPassengerBalance(bookingNumber, passengerID) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationGetPassengerBalance', {
                'BookingNumber': bookingNumber,
                'PassengerID': passengerID
            },
            // Show loading screen
            true);
        }
    }, {
        key: 'getPassengerChangeMail',
        value: function getPassengerChangeMail(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationGetPassengerChangeMail', {
                'BookingNumber': bookingNumber,
                'Language': this.winresCloudService.getLanguage()
            },
            // Don't show loading screen - the page provides its own indicator
            false);
        }

        // Save passenger invoice amounts. The amounts parameter is an object.
        // For example, to set the advace amount as 50 € and the final amount
        // as undefined (e.g. will be defined later): { Advance: 50, Final: null }
        // To give someone a free pass, set their amount(s) to 0.
        // Note that 0 and null do not mean the same thing! 0 is free, null is
        // "we haven't decided the amount yet, check back later".
        // A passenger with both amounts set to zero has a valid "fully-paid"
        // booking, while a passenger with one or both amounts set to null
        // does not, and has to wait until the amounts are defined.

    }, {
        key: 'savePassengerInvoiceAmounts',
        value: function savePassengerInvoiceAmounts(bookingNumber, passengerID, amounts) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationSavePassengerInvoiceAmounts', {
                'BookingNumber': bookingNumber,
                'PassengerID': passengerID,
                'Amounts': amounts
            },
            // Show loading screen
            true);
        }
    }, {
        key: 'assignPaymentToPassengers',
        value: function assignPaymentToPassengers(bookingNumber, bookingPaymentNumber, assignments) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationAssignPaymentToPassengers', {
                'BookingNumber': bookingNumber,
                'BookingPaymentNumber': bookingPaymentNumber,
                'Assignments': assignments
            },
            // Show loading screen
            true);
        }
    }, {
        key: 'payPassengerBalance',
        value: function payPassengerBalance(bookingNumber, passengerID, paymentSettings) {
            // Workaround for testing.
            // Paytrail won't accept the first the URL without this.
            var urlTemplate = paymentSettings.returnUrlTemplate.replace('localhost:8080/#', 'localhost:8080/index.html#');

            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationPayPassengerBalance', {
                'BookingNumber': bookingNumber,
                'PassengerID': passengerID,
                'InternalName': paymentSettings.internalName,
                'InvoiceType': paymentSettings.invoiceType,
                'ReturnUrlTemplate': urlTemplate,
                'Language': this.winresCloudService.getLanguage()
            }, true).then(function (result) {
                if (result && result.RedirectData) {
                    return result;
                } else {
                    throw result;
                }
            }).then(function (result) {
                if (result.HtmlForm) {
                    var form = $(result.RedirectData);
                    $('body').append(form);
                    form.submit();
                } else {
                    window.location = result.RedirectData;
                }
                return true;
            });
        }
    }, {
        key: 'confirmPayment',
        value: function confirmPayment(identifier, status) {
            var returnUrl = '' + window.location;

            return this.winresCloudService.makeRequest('GroupReservationConfirmPassengerPaymentByReturnUrl', {
                'Identifier': identifier,
                'ReturnUrl': returnUrl,
                'Status': status
            }).then(function (result) {
                if (result.User && result.Result == 'Success') {
                    console.log('[GRS] Confirmed payment:', identifier);
                } else if (result.User && result.Result == 'Cancel') {
                    console.log('[GRS] Canceled payment:', identifier);
                } else {
                    // Got some error
                }
                return result;
            });
        }
    }, {
        key: 'getPayments',
        value: function getPayments(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GroupReservationGetPayments', {
                'BookingNumber': bookingNumber
            },
            // Show loading screen
            true);
        }
    }, {
        key: 'findBookingNumber',
        value: function findBookingNumber($stateParams) {
            var _this = this;

            return this.getBookingNumberFromParameter($stateParams).catch(function () {
                return _this.GetBookingNumberFromUser();
            });
        }
    }, {
        key: 'getBookingNumberFromParameter',
        value: function getBookingNumberFromParameter($stateParams) {
            var bookingNumber = $stateParams.bookingNumber;
            if (bookingNumber) {
                return this.$q.resolve(bookingNumber);
            } else {
                return this.$q.reject('No booking number provided.');
            }
        }
    }, {
        key: 'getBookingNumberFromUser',
        value: function getBookingNumberFromUser() {
            var _this2 = this;

            return this.winresCloudService.getUserWhenAvailable().then(function (user) {
                var bookingNumber = user.getBookingNumber();
                if (bookingNumber) {
                    return bookingNumber;
                } else {
                    return _this2.$q.reject('User has no booking number.');
                }
            });
        }
    }]);

    return GroupReservationService;
}();

GroupReservationService.$inject = ['$q', 'winresCloudService'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/groupReservationService.js
// module id = 561
// module chunks = 2